import {strings as translate} from 'locale';

export default function emailValidator(email) {
    const re = /\S+@\S+\.\S+/
    if (!email) return translate.email_emtpy
    if (!re.test(email)) return translate.email_error
    return true
}
